import {PipelineStepStatusCode} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';

export default function isAnalysisSucceeded(analysis: Pick<PipelineGraphQL, 'execution'>): boolean {
  return analysis.execution.steps.every(
    (step) =>
      step.statusCode === PipelineStepStatusCode.SUCCEEDED ||
      step.statusCode === PipelineStepStatusCode.HALTED
  );
}
